import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { IFundraiser } from 'src/app/shared/models/fundraiser.model';
import { EventsService, UtilService, VariablesService } from '../../../shared/services';
@Component({
  selector: 'app-story-tabs',
  templateUrl: './story-tabs.component.html',
  styleUrls: ['./story-tabs.component.scss'],
})
export class StoryTabsComponent implements OnInit, OnChanges {

  @Input() public fundraiser: IFundraiser;
  @Input() public basicinfo;
  @Input() public updates;
  @Input() public isDonated;
  @Input() public sharedCounts;
  @Input() public isFundraiserEnded;
  @Input() public campaingUrl;
  @Input() public currency;
  @Input() public hide_el;
  @Input() comments;
  isMobile: any;
  isLoaded;
  userData;
  params;
  @ViewChild('tabs', { static: true }) tabs: MatTabGroup;
  @ViewChild('sharebtns') sharebtns: ElementRef<HTMLElement>;
  @ViewChild('socailShare') socailShare: ElementRef<HTMLElement>;
  @Output() public tabIndex = new EventEmitter();

  inViewPort = {
    'comments': false
  };

  constructor(
    private utilService: UtilService,
    private renderer: Renderer2,
    public variablesService: VariablesService,
    private eventsService: EventsService,
    public actRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.onWindowScroll();
    this.params = this.actRoute.snapshot.queryParams;
    this.variablesService.userData.subscribe(res => {
      this.userData = res;
    });
  }
  ngOnChanges() {
    if (this.tabs?._elementRef?.nativeElement && this.sharebtns?.nativeElement) {
      this.tabs._elementRef.nativeElement.children[0].appendChild(this.sharebtns.nativeElement);
      this.sharebtns.nativeElement.style.display = 'flex';
    }
  }
  /**Check if fundraiser ends and swith to update
   * tab if there any updates
   */
  checkForUpdate() {
    return this.isFundraiserEnded && this.updates && this.updates.total ? 1 : 0;
  }
  /**On the chnage of the tab */
  onTabChange(event) {
    if (this.utilService.isBrowser && event) {
      this.tabIndex.emit(event.index);
      this.tabs._elementRef.nativeElement.scrollIntoView(
        { behavior: 'instant', block: 'start', inline: 'nearest' }
      );
      if (event.tab && event.tab.textLabel === 'Documents' && event.index === 1) {
        this.docPageEvent();
      }
      if (event?.tab?.textLabel === 'Updates') {
        this.updatepageEvent();
      }
    }
  }

  docPageEvent(): void {
    const payload = {
      eventName: 'medical_doc_opened',
      page_name: this.variablesService.pageName,
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
    };
    this.eventsService.sendSystemEvent(payload).subscribe();
  }

  updatepageEvent() {
    const payload = {
      eventName: 'update_tab_opened',
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
    };
    this.eventsService.sendSystemEvent(payload).subscribe();
  }
  /**Set the share condition
   * if update tabs added then show only whatsapp
   * otherwise show both in mobile
   */
  setShare() {
    if (this.isMobile) {
      return this.updates && this.updates.total ? false : true;
    } else {
      return true;
    }
  }
  onWindowScroll() {
    if (this.utilService.isMobile() && this.utilService.isBrowser) {
      this.renderer.listen('window', 'scroll', (_event) => {
        if (this.currency !== 'INR') {
          if (this.tabs?._elementRef?.nativeElement
            && this.socailShare && this.socailShare.nativeElement) {
            const data = this.tabs._elementRef.nativeElement.getBoundingClientRect();
            if (data.top <= 0) {
              this.socailShare.nativeElement.classList.add('sticky-tabs');
              this.socailShare.nativeElement.style.display = 'block';
            } else {
              this.socailShare.nativeElement.style.display = 'none';
              this.socailShare.nativeElement.classList.remove('sticky-tabs');
            }
          }
        }
      });
    }
  }
  /**Set the share buttons in the tabs */
  setShareButtons() {
    if (this.tabs?._elementRef?.nativeElement && this.sharebtns && this.sharebtns.nativeElement) {
      this.tabs._elementRef.nativeElement.children[0].appendChild(this.sharebtns.nativeElement);
      this.sharebtns.nativeElement.style.display = 'flex';
    }
  }
  checkLength(arr) {
    return arr?.length ? true : false;
  }

  inViewPortListner(e, type) {
    if (this.fundraiser && e.visible === true && !this.inViewPort[type] && this.utilService.isBrowser) {
      this.inViewPort[type] = true;
    }
  }
}
